import { useEffect, useState } from 'react';
import { Form, Input, Select, DatePicker, Switch, Button, Card, Row, Col, message, Space, Alert } from 'antd';
import { SaveOutlined, ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import AdminSidebar from '../Components/Sidebar';
import TextArea from 'antd/es/input/TextArea';
import { createOrUpdateSettings, getSettings } from '../redux/slices/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';

function TermsAndConditions() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const dispatch = useDispatch();

    const onReset = () => {
        form.resetFields();
        message.info('Form has been reset');
    };

    const { settings } = useSelector((state) => state?.settings)

    useEffect(() => {
        dispatch(getSettings())
    }, [dispatch])

    useEffect(() => {
        if (settings?.data) {
            form.setFieldsValue({
                terms_and_conditions : settings?.data?.terms_and_conditions
            })
        }
    }, [settings, form])

    const onSubmit = async (values) => {
        setLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(createOrUpdateSettings({
                terms_and_conditions : values.terms_and_conditions,
                type : "Terms and Conditions"
            }));

            if (createOrUpdateSettings.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message);
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('')
                    setAlertType('')
                }, 4000)
            } else {
                setAlertMessage(resultAction?.payload?.error || 'Failed to update terms and conditions');
                setAlertType('danger');
            }

        } catch (error) {
            setAlertMessage('Failed to update terms and conditions');
            setAlertType('danger');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                title="Terms and Conditions"
                style={{ marginBottom: 24 }}
            >
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit}
                    initialValues={{
                        status: 'active',
                        notifications: true,
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Terms and Conditions"
                        name="terms_and_conditions"
                    >
                        <TextArea
                            rows={4}
                            placeholder="Enter Terms and Conditions"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Space>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SaveOutlined />}
                                loading={loading}
                                size="large"
                            >
                                Submit
                            </Button>
                            <Button
                                htmlType="button"
                                onClick={onReset}
                                size="large"
                            >
                                Reset
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
            } />
            
        </>
    );
}

export default TermsAndConditions;